import { useState, useEffect } from "react";
import { wrapError } from "../../utils";

const useGet = (api, path, defaultValue) => {
  const [data, setData] = useState(defaultValue);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    api
      .get(path)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(wrapError(err));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [api, path]);

  return [data, isLoading, error];
};

export default useGet;
